const checkout = {
  secure: 'Sicherer Checkout',
  selectedPlan: 'Ausgewählter Plan',
  tagline: 'Schneller mit Vertrauen starten',
  subTagline: 'Alles, was du für ein sicheres Onboarding und Skalieren brauchst.',
  bullet1: 'Starte mit einer sicheren, schnellen API-Plattform.',
  bullet2: 'Transparente Preise mit planbaren Verlängerungen.',
  bullet3: 'Priorisierter Support, damit du schneller live gehst.',
  title: 'Checkout',
  description: 'Wähle deinen Plan, gib deine Daten an und schließe in zwei Schritten ab.',
  loadError: 'Checkout-Infos konnten nicht geladen werden.',
  stepCustomer: 'Kunde',
  stepPayment: 'Zahlung',
  contact: 'Kontaktinformationen',
  additionalFields: 'Weitere Angaben',
  billingAddressTitle: 'Rechnungsadresse',
  contactDetailsTitle: 'Kontaktdaten',
  email: 'E-Mail',
  emailPlaceholder: 'du@example.com',
  plan: 'Plan auswählen',
  package: 'Credit-Paket auswählen',
  plansToggle: 'Pläne',
  packagesToggle: 'Credit-Pakete',
  recommended: 'Empfohlen',
  freeTrialLabel: '{{count}}-tägige kostenlose Testphase',
  noCardRequired: 'Keine Kreditkarte erforderlich',
  individualPlans: 'Pläne für Einzelpersonen',
  individualPlansHelper: 'Für persönliche Konten und Solo-Builder',
  teamPlans: 'Team-Pläne',
  teamPlansHelper: 'Für Workspaces mit gemeinsamem Zugriff',
  noPlansForType: 'Für diese Zielgruppe gibt es noch keine Pläne.',
  noPackagesForType: 'Für diese Zielgruppe gibt es noch keine Credit-Pakete.',
  switchPlanType: 'Wechsle zwischen Einzel- und Team-Plänen.',
  noPricingForPlan: 'Keine Preisoptionen für diesen Plan konfiguriert.',
  noPackagePricing: 'Keine Preisoptionen für dieses Paket konfiguriert.',
  packageCredits: '{{credits}} Credits',
  includedSeatsLabel: 'Enthaltene Sitzplätze',
  includedSeatsValue: '{{count}} Sitzplätze',
  includedSeatsInline: 'Enthält {{count}} Sitzplätze',
  features: 'Enthaltene Funktionen',
  moreFeatures: 'weitere Funktionen',
  teamHeading: 'Team-Inhaberschaft',
  teamSubheading: 'Bestimme einen Workspace-Owner und gib den Teamnamen an.',
  teamBadge: 'Teams',
  roleIndividual: 'Einzelperson',
  roleTeamOwner: 'Team-Owner',
  teamName: 'Workspace-Name',
  workspaceNameRequired: 'Workspace-Name ist erforderlich.',
  teamNamePlaceholder: 'z. B. Acme Platform Team',
  haveAccount: 'Bereits ein Konto?',
  continue: 'Weiter',
  review: 'Übersicht',
  verificationPending: 'Bitte bestätige deine E-Mail, um abzuschließen.',
  stepLabel: 'Schritt 2 von 2',
  noPlan: 'Kein Plan',
  billing: 'Abrechnung',
  introSummary: 'Intro: {{introPrice}} für {{cycles}} Abrechnungszyklen, danach {{recurringPrice}} {{cycleSuffix}}',
  cycleSuffixMonthly: 'pro Monat',
  cycleSuffixYearly: 'pro Jahr',
  cycleSuffixEveryMonths: 'alle {{count}} Monate',
  billingCycles: {
    monthly: 'Monatlich',
    monthlyBilling: 'Monatliche Abrechnung',
    yearly: 'Jährlich',
    yearlyBilling: 'Jährliche Abrechnung',
    annual: 'Jährlich',
  },
  termsLabelPrefix: 'Ich stimme den',
  termsLabelSuffix: ' zu',
  termsRequired: 'Du musst den Nutzungsbedingungen zustimmen, um fortzufahren.',
  requiredField: 'Dieses Feld ist erforderlich.',
  phoneInvalid: 'Bitte eine gültige Telefonnummer eingeben.',
  companyTooLong: 'Der Unternehmensname darf höchstens 255 Zeichen lang sein.',
  verifyPrompt: 'Prüfe dein Postfach und bestätige deine E-Mail.',
  verifyBody: 'Wir haben dir eine E-Mail zur Verifizierung geschickt. Folge dem Link in deinem Posteingang.',
  back: 'Zurück',
  goToLogin: 'Zum Login',
  totalDue: 'Gesamtkosten',
  paymentNext: 'Zahlung erforderlich. Folge den Anweisungen.',
  noPaymentNow: 'Keine Zahlung jetzt nötig.',
  complete: 'Weiter',
  paymentRequired: 'Checkout erstellt. Weiter zur Zahlung.',
  completed: 'Registrierung erfolgreich abgeschlossen.',
  successTitle: 'Checkout abgeschlossen',
  successSubtitle: '',
  paymentRequiredTitle: 'Zahlung erforderlich',
  paymentRequiredBody: 'Folge den Zahlungsanweisungen, um den Checkout abzuschließen.',
  paymentDetails: 'Zahlungsdetails',
  paymentUnavailable: 'Stripe ist für diesen Checkout nicht konfiguriert. Bitte kontaktiere den Support.',
  paymentError: 'Zahlung fehlgeschlagen. Bitte prüfe deine Angaben und versuche es erneut.',
  alreadyRegistered: 'Du hast bereits ein Konto. Bitte melde dich an.',
  payNow: 'Jetzt bezahlen',
  processingPayment: 'Zahlung wird verarbeitet...',
  trialCardNotice: 'Heute keine Abbuchung; die Karte wird für die Verlängerung gespeichert.',
  supportDetails: 'Support-Details',
  paymentIntentId: 'Payment Intent',
  subscriptionId: 'Abonnement',
  setupIntentId: 'Setup Intent',
  error: 'Checkout konnte nicht abgeschlossen werden.',
  selectionMissing: 'Bitte wähle einen Plan oder ein Credit-Paket aus.',
  noPricing: 'Für diesen Plan gibt es keine Preise. Bitte wähle einen anderen.',
  selectedPackage: 'Ausgewähltes Paket',
  packageSummary: 'Paket',
  noPackage: 'Kein Paket',
  creditsLabel: 'Credits',
  creditsValue: '{{credits}} Credits',
  default: 'Standard',
  teams: 'Teams',
  fields: {
    company: 'Unternehmen',
    contact_phone: 'Telefon',
    billing: {
      address_line_1: 'Straße und Hausnummer',
      address_line_2: 'Adresszusatz',
      address_city: 'Ort',
      address_state: 'Bundesland/Region',
      address_postal_code: 'Postleitzahl',
      address_country: 'Land',
    },
  },
  placeholders: {
    company: 'Acme GmbH',
    contact_phone: '+49 30 123456',
    billing: {
      address_line_1: 'Straße und Hausnummer',
      address_line_2: 'Wohnung, Suite usw.',
      address_city: 'Ort',
      address_state: 'Bundesland/Region',
      address_postal_code: 'Postleitzahl',
      address_country: 'Ländercode (z. B. DE)',
    },
  },
} as const;

export default checkout;
